import React from "react";

export function PageHeader({ title, subtitle, action }) {
    return (
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
            <div>
                <div className="text-xs uppercase tracking-[0.2em] text-secondary-dark font-semibold">{subtitle || ""}</div>
                <h1 className="mt-1 font-heading text-3xl sm:text-4xl text-ocean-700">{title}</h1>
            </div>
            {action}
        </div>
    );
}

export default PageHeader;
